import {Tooltip} from 'platform/components';
import {HStack, Icon, Text} from 'platform/foundation';

import {truncateTitleAtWordBoundary} from '../utils/truncateTitleAtWordBoundary';

interface PlatformTitleLimitChipProps {
  label: string;
  limit: number;
  value: string;
}

export function PlatformTitleLimitChip(props: PlatformTitleLimitChipProps) {
  const isOverLimit = props.value.length > props.limit;

  // The tooltip previews the exact text these platforms will receive; the warning icon
  // already says it was truncated. Computed locally and indicative — the BE export
  // clamp is the authority (it re-truncates and sanitizes on its own).
  const preview = truncateTitleAtWordBoundary(props.value, props.limit);

  return (
    <Tooltip label={preview} isDisabled={preview.length === 0} placement="top">
      <HStack spacing={1} align="center">
        <Icon
          size={4}
          value={isOverLimit ? 'alert/warning' : 'action/check_circle'}
          color={isOverLimit ? 'severity.warning' : 'severity.success'}
        />
        <Text size="xSmall" color="secondary">
          {`${props.label} (${props.limit})`}
        </Text>
      </HStack>
    </Tooltip>
  );
}
